import React from 'react';


import {PersonalBox} from "../personal-box/Personal-box";
import {ClassesCart} from "./student-carts/сlasses-cart/Classes-cart";
import {LevelCart} from "./student-carts/level-carts/Level-cart";
import {PaymentsCart} from "./student-carts/payments-carts/Payments-cart";
import {ActsCart} from "./student-carts/acts-carts/Acts-cart";

export const PersonalCabinetStudent = () => {

    return (
        <div className="tabs-content">
            <div className="tab">
                <PersonalBox/>
                <div className="info-cards-box">
                    <ClassesCart/>
                    <LevelCart/>
                    <PaymentsCart/>
                    <ActsCart/>
                </div>
            </div>
        </div>
    );
};

